import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import Layout from '../components/Layout';
import {api} from '../../api';


const STATUS_COLORS = {
  DRAFT: 'bg-gray-100 text-gray-800',
  POSTED: 'bg-green-100 text-green-800',
  VOID: 'bg-red-100 text-red-800',
};

export default function JournalEntries() {
  const [entries, setEntries] = useState([]);
  const [filterStatus, setFilterStatus] = useState('');

  useEffect(() => {
    const url = filterStatus ? `/journal-entries?status=${filterStatus}` : `/journal-entries`;
    api(url).then(r => r.json()).then(setEntries).catch(() => {});
  }, [filterStatus]);

  return (
    <Layout>
      <div className="bg-white rounded-lg shadow">
        <div className="p-4 md:p-6 border-b">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-4">
            <h1 className="text-2xl font-bold text-gray-900">Journal Entries</h1>
            <Link to="/accounting/journal-entries/new" className="px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700">
              New Entry
            </Link>
          </div>
          <select value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)} className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-600">
            <option value="">All Statuses</option>
            <option value="DRAFT">Draft</option>
            <option value="POSTED">Posted</option>
            <option value="VOID">Void</option>
          </select>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Reference</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase hidden md:table-cell">Description</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {entries.map((je) => (
                <tr key={je.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap text-gray-900">{je.entryDate}</td>
                  <td className="px-6 py-4 whitespace-nowrap font-medium">
                    <Link to={`/accounting/journal-entries/${je.id}`} className="text-emerald-600 hover:text-emerald-800">{je.reference || je.id.substring(0, 8)}</Link>
                  </td>
                  <td className="px-6 py-4 text-gray-600 hidden md:table-cell">{je.description || '—'}</td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`px-3 py-1 rounded-full text-sm font-medium ${STATUS_COLORS[je.status] || 'bg-gray-100 text-gray-800'}`}>{je.status}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {entries.length === 0 && <div className="text-center py-12 text-gray-500">No journal entries found.</div>}
        </div>
      </div>
    </Layout>
  );
}
